import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { ThemeService } from '../theme/theme-service.service';

@Component({
  selector: 'app-friend-invitation',
  templateUrl: './friend-invitation.component.html',
  styleUrls: ['./friend-invitation.component.scss']
})
export class FriendInvitationComponent implements OnInit {

  public BoxesCharity = [
    {}, 
    {}, 
    {}, 
    {}, 
    {}, 
  ]

  constructor(private router: Router, public sideNavBarVisibilityService: SideNavBarVisibilityService, public themeService: ThemeService) { }

  ngOnInit() {
  }

  goTo() {
    this.router.navigate(['/charity-invitation-sent']);
  }

}
